export default "__VITE_ASSET__CT11srzI__"